import { expectAtIndex } from "./expectAtIndex.js";

/**
 * Removes elements from the end of an array until the passed predicate returns true.
 */
export const removeRightWhile = <T>(
  array: Array<T>,
  predicate: (item: T) => boolean,
) => {
  let rightIndex = array.length;
  while (rightIndex-- && !predicate(expectAtIndex(array, rightIndex)));
  array.length = rightIndex + 1;
};
